/**
 * THE CHALLENGE ON THE SIGN-IN BOX.
 *
 * WHAT IT IS FOR, and it is not "stopping bots" in general. The sign-in box
 * tells an unknown address that it has no access — decided on 11 August,
 * because the alternative misled every honest person who had simply not been
 * added yet. The cost is that the box can be used to test addresses one at a
 * time and learn who works somewhere.
 *
 * A rate limit was the obvious answer and is the wrong one. Thirty attempts an
 * hour is already enforced, and it is the SAME allowance real people sign in
 * with: measured on 11 August, one burst of refusals affected other addresses
 * too. A smaller number would make it cheaper for one person to stop everybody
 * signing in. A challenge raises the cost of the automated attempt without
 * lowering the ceiling for the honest one.
 *
 * THE SITE KEY IS PUBLIC BY DESIGN, exactly as the Supabase and Firebase keys
 * in this repository are. It identifies the widget and grants nothing: the
 * token it produces is checked by Cloudflare against the SECRET, which lives on
 * Supabase's servers and is written blind by `npm run captcha`.
 *
 * EMPTY MEANS OFF, everywhere, with no second flag to disagree with it. An
 * environment without a key shows no widget and sends no token, and Supabase
 * with no secret asks for none — so the two halves cannot end up in different
 * states through anybody forgetting one of them.
 */
/*
 * PROVING IT WORKS WITHOUT A CLOUDFLARE ACCOUNT. Cloudflare publishes keys that
 * always behave the same way, and both branches were checked with them on
 * 11 August rather than reasoned about:
 *
 *   1x00000000000000000000AA  always passes, and solves without showing itself
 *   3x00000000000000000000FF  always forces the visible "verify you are human"
 *
 * Paste one in, `npm run dev`, and put it back to empty afterwards. A test key
 * left here is a challenge that lets anybody through.
 */
export const TURNSTILE_SITE_KEY = '';

export const captchaOn = (): boolean => TURNSTILE_SITE_KEY.length > 0;
